<template>
  <div class="page w-100">
    <slot />
    <base-alert
      sticky
      :show="showGlobalMessage"
      :variant="globalMessage.type"
      @dismissed="RESET_GLOBAL_MESSAGE"
      :auto-dismiss="5"
      fade
    >
      {{ globalMessage.message }}
    </base-alert>
  </div>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex';
import * as types from '@/store/types';
import BaseAlert from '@/components/BaseAlert.vue';

export default {
  components: { BaseAlert },
  computed: {
    ...mapGetters({
      globalMessage: types.GET_GLOBAL_MESSAGE,
    }),

    showGlobalMessage() {
      return !!this.globalMessage.message;
    },
  },
  methods: {
    ...mapMutations([
      types.RESET_GLOBAL_MESSAGE,
    ]),
  },
};
</script>
